module.exports = __webpack_public_path__ + "assets/1440c9ca4433844357cedfb6575ad86a.png";